import React, { useState, useEffect } from 'react';
import { ChevronUp } from 'lucide-react';

interface BackToTopProps {
  position?: 'bottom-left' | 'bottom-right';
}

const BackToTop: React.FC<BackToTopProps> = ({ position = 'bottom-right' }) => {
  const [isVisible, setIsVisible] = useState(false);
  
  const toggleVisibility = () => {
    if (window.pageYOffset > 300) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };
  
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
  
  useEffect(() => {
    window.addEventListener('scroll', toggleVisibility);
    
    return () => {
      window.removeEventListener('scroll', toggleVisibility);
    };
  }, []);

  const positionClass = position === 'bottom-left' ? 'left-6' : 'right-6';
  
  return (
    <div className={`fixed bottom-6 ${positionClass} transition-opacity duration-300 ${isVisible ? 'opacity-100' : 'opacity-0 pointer-events-none'}`}>
      <button
        onClick={scrollToTop}
        className="bg-stone-800 text-white p-3 rounded-full shadow-md hover:bg-stone-700 transition-all focus:outline-none focus:ring-2 focus:ring-stone-500"
        aria-label="Back to top"
      >
        <ChevronUp size={24} />
      </button>
    </div>
  );
};

export default BackToTop;
